import { Videos } from '../types';

export default class VideosState {
  videos: Videos.Video[] = [];
}
